import { InjectionToken, Signal } from '@angular/core';

/**
 * Injection-token waarmee een content-component dat in een floating panel
 * gemount wordt zijn data ontvangt als reactieve `Signal<D>`. Door dit als
 * signal door te geven werkt {@link FloatingPanelRef.updateData} reactief
 * door zonder de component opnieuw te instantiëren.
 */
export const FLOATING_PANEL_DATA = new InjectionToken<Signal<unknown>>('FLOATING_PANEL_DATA');
